import { FC } from 'react';
import { Card, Divider, Flex, Heading, Text } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import { toEuro } from '@sales-conversation/src/utils/stringUtils';
import useflowsProductBasketStore from '../../store/zustand/flows-products/flowsProductBasketStore';
import {
  getTotalDiscount,
  getTotalInsurancesPrice,
  getTotalPackagesPrice,
  getGrandTotal,
} from '../../utils/basketCalculations';

const FlowProductsSideBarBasketPriceSummary: FC = () => {
  const { t } = useTranslation();

  // Subscribe to the basket store to trigger re-renders when packages or insurances change
  useflowsProductBasketStore((state) => state.packages);
  useflowsProductBasketStore((state) => state.insurances);

  const insurancesPrice = getTotalInsurancesPrice();
  const packagesPrice = getTotalPackagesPrice();
  const discountAmount = getTotalDiscount();
  const total = getGrandTotal();

  return (
    <Card
      mx="4"
      bg="gray.ultraLight"
      borderColor="gray.50"
      boxShadow="none"
      mt="4"
    >
      <Heading as="h3" size="md" mb="4">
        {t('FLOWS_PRODUCT-BASKET_PRICE-SUMMARY_TITLE')}
      </Heading>
      <Flex justify="space-between" mb="2" textStyle="largeBody">
        <Text>{t('FLOWS_PRODUCT-BASKET_PRICE-SUMMARY_INSURANCES')}:</Text>
        <Text>{toEuro(insurancesPrice)}</Text>
      </Flex>
      <Flex justify="space-between" mb="2" textStyle="largeBody">
        <Text>{t('FLOWS_PRODUCT-BASKET_PRICE-SUMMARY_PACKAGES')}:</Text>
        <Text>{toEuro(packagesPrice)}</Text>
      </Flex>
      <Flex
        justify="space-between"
        mb="2"
        textStyle="largeBody"
        color="primary.500"
      >
        <Text>{t('FLOWS_PRODUCT-BASKET_PRICE-SUMMARY_DISCOUNT')}:</Text>
        <Text>-{toEuro(discountAmount)}</Text>
      </Flex>
      <Divider my="4" borderColor="gray.200" />
      <Flex justify="space-between">
        <Text textStyle="h5Headline">
          {t('FLOWS_PRODUCT-BASKET_PRICE-SUMMARY_TOTAL')}:
        </Text>
        <Text textStyle="h5Headline">{toEuro(total)}</Text>
      </Flex>
    </Card>
  );
};

export default FlowProductsSideBarBasketPriceSummary;
